import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss'

const YES = 'YES';
const NO = 'NO';

const YesNoTable = ({ rows, onChange, selections, disabled = false }) => {

  const radioChanged = (key, event) => {
    onChange({ ...selections, [key]: event.target.value });
  }

  const radios = (key) => {
    return (
      <div className={styles.optionWrapper}>
        <div className={styles.option}>
          <label className={styles.radio} disabled={disabled}>
            <input
              disabled={disabled}
              type="radio"
              value={YES}
              onChange={(event) => radioChanged(key, event)}
              checked={selections[key] == YES.toString()}
            />
            <span className={styles.radioControl}></span>
            <span className={styles.optionText}>Yes</span>
          </label>
        </div>
        <div className={styles.option}>
          <label className={styles.radio} disabled={disabled}>
            <input
              disabled={disabled}
              type="radio"
              value={NO}
              onChange={(event) => radioChanged(key, event)}
              checked={selections[key] == NO.toString()}
            />
            <span className={styles.radioControl}></span>
            <span className={styles.optionText}>No</span>
          </label>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className={styles.yesNoWrapper}>
        {rows.map((row) => <div key={row.key} className={styles.optionRow}>
          <div className={styles.rowInfo}>
            <h4>{row.title}</h4>
            <p>{row.tip}</p>
          </div>
          {radios(row.key)}
        </div>)}
      </div>
    </div>
  );
}

YesNoTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string,
    tip: PropTypes.string,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  selections: PropTypes.object,
};

YesNoTable.defaultProps = {
  selections: {},
};

export default YesNoTable
